import React, { useEffect, useRef } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../ui/card';

// Mirrors a real diagnostic log: one monospace line per request/response, e.g.
//   Tester -> ECU   27 01
//   ECU -> Tester   67 01 12 34 56 78
// Plain stacked <div> rows rather than a <table> — this project has a known hydration-error
// gotcha with raw HTML tables (see AUTOXIUM memory), and a two-column log like this needs no
// table semantics anyway.
const MessageTracePanel = ({ log }) => {
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, [log]);

  return (
    <Card className="technical-card" data-testid="sa-message-trace">
      <CardHeader>
        <CardTitle className="font-chivo uppercase tracking-tight text-base">UDS Message Trace</CardTitle>
        <CardDescription>Every 0x27 request and response, in order.</CardDescription>
      </CardHeader>
      <CardContent>
        <div ref={scrollRef} className="max-h-72 overflow-y-auto space-y-1.5 bg-muted/30 rounded-md p-4">
          {log.length === 0 && <p className="text-xs text-muted-foreground">No requests sent yet.</p>}
          {log.map((entry) => {
            const isTester = entry.direction === 'tester';
            return (
              <div key={entry.id} className="flex flex-wrap items-baseline gap-x-3 font-mono text-xs md:text-sm">
                <span className={`w-32 shrink-0 ${isTester ? 'text-foreground' : 'text-autoxium-blue'}`}>
                  {isTester ? 'Tester → ECU' : 'ECU → Tester'}
                </span>
                <span className="tracking-widest">{entry.bytesHex}</span>
                {entry.note && <span className="text-[11px] text-muted-foreground">({entry.note})</span>}
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};

export default MessageTracePanel;
